import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { gsap } from 'gsap';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navRef = useRef(null);
  const logoRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    // Animation sobre d'apparition de la navigation au chargement
    gsap.fromTo(navRef.current, 
      { opacity: 0 },
      { opacity: 1, duration: 0.6, ease: "power2.out" }
    );

    gsap.fromTo(logoRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.8, delay: 0.2, ease: "power2.out" }
    );

    // Animation subtile des liens de menu
    const menuItems = menuRef.current?.querySelectorAll('li');
    if (menuItems) {
      gsap.fromTo(menuItems,
        { opacity: 0 },
        { opacity: 1, duration: 0.8, stagger: 0.1, delay: 0.4, ease: "power2.out" }
      );
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Fermer le menu mobile lors du changement de page
    setIsMenuOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navItems = [
    { path: '/', label: 'Accueil' },
    { path: '/services', label: 'Services' },
    { path: '/a-propos', label: 'À Propos' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav ref={navRef} className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-content">
          {/* Logo */}
          <Link to="/" className="logo" ref={logoRef}>
            <img src="/logo.png" alt="Atout Canin - logo" className="logo-img" />
            <span className="logo-text">Atout Canin</span>
          </Link>

          {/* Menu Desktop */}
          <ul ref={menuRef} className="nav-links desktop">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={location.pathname === item.path ? 'active' : ''}
                >
                  <span className="nav-label">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>

          {/* Bouton CTA */}
          <Link to="/contact" className="btn btn-secondary nav-cta">
            Devis Gratuit
          </Link>

          {/* Menu Mobile Toggle */}
          <button 
            className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Ouvrir/fermer le menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Menu Mobile */}
        <ul className={`nav-links mobile ${isMenuOpen ? 'mobile-open' : ''}`}>
          {navItems.map((item) => (
            <li key={item.path}>
              <Link 
                to={item.path} 
                className={location.pathname === item.path ? 'active' : ''}
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="nav-label">{item.label}</span>
              </Link>
            </li>
          ))}
          <li>
            <Link to="/contact" className="btn btn-secondary" onClick={() => setIsMenuOpen(false)}>
              Devis Gratuit
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation; 